import React from "react";
import { Button } from "react-bootstrap";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import "./ActionConfirmForm.scss";

const ActionConfirmForm = props => {
  return (
    <div className="action-confirm-form">
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
      </div>
      <div className="user-container d-flex flex-column align-items-center p-4">
        <div>
          <div className="action-title">{props.title}</div>
          <div className="action-question">{props.question}</div>
        </div>
        <div className="actions-box mt-4">
          <Button variant="outline-danger" className="mr-2" size="sm" onClick={props.onClose}>NO</Button>
          <Button
            variant="outline-danger"
            className="mr-2"
            size="sm"
            onClick={props.onConfirm}
          >
            YES
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ActionConfirmForm;
